import { render, staticRenderFns } from "./procedure-companies-avatar.vue?vue&type=template&id=172cb1c3&"
import script from "./procedure-companies-avatar.vue?vue&type=script&lang=js&"
export * from "./procedure-companies-avatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports